// extracted by mini-css-extract-plugin
module.exports = {"text":"PhenoforgeMkI_text__TS0Ac","video":"PhenoforgeMkI_video__1_XqC"};